/**
 * Semáforo de plazos de préstamo (fiel al Dashboard actual).
 * Los días se cuentan desde la última modificación del expediente.
 */
export const PLAZOS = ['Reciente', 'Normal', 'Por Vencer', 'Vencido'];
/** Umbrales en días, tal como se muestran en el dashboard. */
export const UMBRALES_PLAZO = {
    reciente: 10, // 0-10 días
    normal: 20, // 11-20 días
    porVencer: 30, // 21-30 días
    // vencido: más de 30 días
};
/** Clasifica un número de días en el semáforo. */
export function clasificarPlazo(dias) {
    if (dias <= UMBRALES_PLAZO.reciente)
        return 'Reciente';
    if (dias <= UMBRALES_PLAZO.normal)
        return 'Normal';
    if (dias <= UMBRALES_PLAZO.porVencer)
        return 'Por Vencer';
    return 'Vencido';
}
/** Días transcurridos entre una fecha y ahora. */
export function diasTranscurridos(desde, ahora = new Date()) {
    const ms = ahora.getTime() - desde.getTime();
    return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}
/** Color asociado a cada plazo (para la UI). */
export const COLOR_PLAZO = {
    Reciente: '#1b7a3d',
    Normal: '#1565c0',
    'Por Vencer': '#8a6d00',
    Vencido: '#b3261e',
};
//# sourceMappingURL=plazos.js.map